import React, { useEffect, useState } from 'react';
import { Form, Input, Button, InputNumber, Select, Row, Col, Card, DatePicker, Divider, Checkbox, Typography, Tooltip } from 'antd';
import { ServicetypeService } from '../../../Services/Manage/ServicetypeService';
import { ConfigurationService } from '../../../Services/Manage/ConfigurationService';
import { EnquiryService } from '../../../Services/Manage/EnquiryService';
import { UserService } from '../../../Services/Manage/UserService';
import { AddEmployeesService } from '../../../Services/Manage/AddEmployeesService';

import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import { Dropdown, Space } from "antd";
import {
  DownOutlined, FileTextOutlined, BankOutlined, UserOutlined,
  ShoppingOutlined, DesktopOutlined, ProjectOutlined,
  FileSearchOutlined, PhoneOutlined,
} from "@ant-design/icons";
const compactFormStyle = `
  .ant-form-item { margin-bottom: 15px !important; }
  .ant-card-body { padding: 16px 16px !important; }
  .ant-card { margin-bottom: 16px !important; }
  .ant-form-item-label { padding-bottom: 2px !important; }
  .ant-form-item-label > label { height: 20px !important; }
`;
dayjs.extend(weekday);
dayjs.extend(localeData);

const { TextArea } = Input;

const SourceDropdown = ({ value, onChange }) => {
  const [selected, setSelected] = useState(value || "");
  const [open, setOpen] = useState(false);
  const [customInput, setCustomInput] = useState(value || "");

  const items = [
    { key: "Telecalling", label: "Telecalling" },
    { key: "Reference", label: "Reference" },
    { key: "Walk-in", label: "Walk-in" },
  ];

  const handleMenuClick = ({ key }) => {
    setSelected(key);
    setCustomInput(key);
    onChange?.(key);
    setOpen(false);
  };

  const handleCustomInput = (e) => {
    const val = e.target.value;
    setCustomInput(val);
    setSelected(val);
    onChange?.(val);
  };

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      menu={{
        items,
        onClick: handleMenuClick,
        selectable: true,
        selectedKeys: [selected],
      }}
    >
      <Space style={{ width: "100%" }}>
        <Input
          size="large"
          placeholder="Select or type source"
          value={customInput}
          onChange={handleCustomInput}
          suffix={<DownOutlined onClick={() => setOpen(!open)} />}
        />
      </Space>
    </Dropdown>
  );
};

const CardTitle = ({ icon, no, text }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      color: "rgba(14, 93, 146, 0.95)",
    }}
  >
    {icon}
    <span style={{ fontWeight: 600 }}>{no}. {text}</span>
  </span>
);

const CreateEnquiry = ({ initialValues, onSubmit, onCancel, handleEQNo }) => {
  const [form] = Form.useForm();
  const selectedCurrency = Form.useWatch('currency', form);

  const _enqPerm = (() => {
    try {
      const raw = localStorage.getItem("ome_permission");
      const parsed = JSON.parse(raw);
      const perms = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
      return perms.find(p => p.link === '/enquiry') || {};
    } catch { return {}; }
  })();
  const canViewAll = _enqPerm.view_all === true;

  const [optionUsers, setOptionUsers] = useState([]);
  const [enquiryNo, setEnquiryNo] = useState('');
  const [optionService, setOptionService] = useState([]);
  const [optionServiceType, setOptionServiceType] = useState([]);
  const [optionStatus, setOptionStatus] = useState([]);
  const [optionLeadSource, setOptionLeadSource] = useState([]);
  const [optionIndustry, setOptionIndustry] = useState([]);

  const [optionDeployment, setOptionDeployment] = useState([]);
  const [optionFollowUpType, setOptionFollowUpType] = useState([]);

  const [countries, setCountries] = useState([]);
  const [currencyMap, setCurrencyMap] = useState({});   // { countryName: "INR" }
  const [stateOptions, setStateOptions] = useState([]);

  const [optionCrncy, setCrncy] = useState([]);

  const [allServices, setAllServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);

  const [optionProducts, setOptionProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);

  const companySizeOptions = [
    { value: "1-10", label: "1-10" },
    { value: "11-50", label: "11-50" },
    { value: "51-200", label: "51-200" },
    { value: "201-500", label: "201-500" },
    { value: "501-1000", label: "501-1000" },
    { value: "1000+", label: "1000+" },
  ];

  const currencySymbols = {
    INR: "₹", USD: "$", EUR: "€", GBP: "£", JPY: "¥",
    AUD: "A$", CAD: "C$", AED: "د.إ", SGD: "S$",
    PKR: "₨", BDT: "৳", LKR: "Rs", NPR: "₨",
  };
  const cur = currencySymbols[selectedCurrency] || selectedCurrency || "₹";
  const useIndianUnits = ["INR", "PKR", "BDT", "LKR", "NPR"].includes(selectedCurrency || "INR");


  const annualRevenueOptions = useIndianUnits
    ? [
      { value: "<1Cr", label: `Less than ${cur} 1 Cr` },
      { value: "1-10Cr", label: `${cur} 1 - 10 Cr` },
      { value: "10-50Cr", label: `${cur} 10 - 50 Cr` },
      { value: "50-100Cr", label: `${cur} 50 - 100 Cr` },
      { value: "100Cr+", label: `${cur} 100 Cr+` },
    ]
    : [
      { value: "<1Cr", label: `Less than ${cur} 1 Million` },
      { value: "1-10Cr", label: `${cur} 1 - 10 Million` },
      { value: "10-50Cr", label: `${cur} 10 - 50 Million` },
      { value: "50-100Cr", label: `${cur} 50 - 100 Million` },
      { value: "100Cr+", label: `${cur} 100 Million+` },
    ];

  const budgetRangeOptions = useIndianUnits
    ? [
      { value: "<1L", label: `Less than ${cur} 1 Lakh` },
      { value: "1-5L", label: `${cur} 1 - 5 Lakh` },
      { value: "5-10L", label: `${cur} 5 - 10 Lakh` },
      { value: "10-25L", label: `${cur} 10 - 25 Lakh` },
      { value: "25L+", label: `${cur} 25 Lakh+` },
    ]
    : [
      { value: "<1L", label: `Less than ${cur} 100K` },
      { value: "1-5L", label: `${cur} 100K - 500K` },
      { value: "5-10L", label: `${cur} 500K - 1M` },
      { value: "10-25L", label: `${cur} 1M - 2.5M` },
      { value: "25L+", label: `${cur} 2.5M+` },
    ];

  const currentProcessOptions = [
    { value: "Manual", label: "Manual / Paper-based" },
    { value: "Excel", label: "Excel / Spreadsheets" },
    { value: "Legacy Software", label: "Legacy Software" },
    { value: "Other ERP", label: "Other ERP" },
    { value: "None", label: "None" },
  ];
  const priorityOptions = [
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" },
    { value: "Urgent", label: "Urgent" },
  ];
  // const budgetRangeOptions = [
  //     { value: "<1L", label: `Less than ${cur} 1 Lakh` },
  //     { value: "1-5L", label: `${cur} 1 - 5 Lakh` },
  //     { value: "5-10L", label: `${cur} 5 - 10 Lakh` },
  //     { value: "10-25L", label: `${cur} 10 - 25 Lakh` },
  //     { value: "25L+", label: `${cur} 25 Lakh+` },
  //   ];
  const deploymentTypeOptions = [
    { value: "Cloud", label: "Cloud" },
    { value: "On-Premise", label: "On-Premise" },
    { value: "Hybrid", label: "Hybrid" },
  ];
  const followUpTypeOptions = [
    { value: "Call", label: "Call" },
    { value: "Email", label: "Email" },
    { value: "Meeting", label: "Meeting" },
    { value: "Demo", label: "Demo" },
  ];

  const [followUps, setFollowUps] = useState([]);

  const [followUpInput, setFollowUpInput] = useState({
    date: null,
    follow_up_type: null,
    summary: "",
  });

  const serviceTotal = selectedServices.reduce(
    (sum, item) => sum + Number(item.unit_price || 0),
    0
  );

  const productTotal = selectedProducts.reduce(
    (sum, item) => sum + Number(item.unit_price || 0),
    0
  );

  // Auto-fill Total Amount from service + product totals (still editable)
  useEffect(() => {
    form.setFieldsValue({ total_amount: serviceTotal + productTotal });
  }, [serviceTotal, productTotal]);



  const handleAddFollowUp = () => {
    if (!followUpInput.date && !followUpInput.follow_up_type && !followUpInput.summary) return;
    const _ome = JSON.parse(localStorage.getItem("ome_user") || "{}");
    const _by = _ome?.name || _ome?.user_name || "";
    setFollowUps([
      ...followUps,
      {
        current_date: dayjs().format("DD-MM-YYYY"),
        date: followUpInput.date,
        follow_up_type: followUpInput.follow_up_type,
        summary: followUpInput.summary,
        follow_up_by: _by,
      },
    ]);
    setFollowUpInput({ date: null, follow_up_type: null, summary: "" });
  };
  const handleFollowUpChange = (index, field, value) => {
    const updated = [...followUps];
    updated[index][field] = value;
    setFollowUps(updated);
  };

  const getAllServices = async () => {
    try {
      const request = await ServicetypeService.getAllServices();

      const activeServices = request.data.filter(
        item => item.status === "Active"
      );

      setAllServices(activeServices);

      setOptionService(
        activeServices.map(item => ({
          value: item.id,
          label: item.service_name
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getAllUsers = async () => {
    try {
      const request = await AddEmployeesService.getByDepartment("Sales");
      setOptionUsers(
        (request.data || [])
          .filter(item => item.status === "Active")
          .map(item => ({
            value: item.name,
            label: `${item.name}${item.uid ? ` (${item.uid})` : ""}`,
          }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleServiceChange = (serviceId) => {
    const selected = allServices.find(
      item => Number(item.id) === Number(serviceId)
    );



    if (!selected) return;

    const alreadyAdded = selectedServices.some(
      item => Number(item.service_id) === Number(selected.id)
    );

    if (alreadyAdded) return;

    setSelectedServices([
      ...selectedServices,
      {
        service_id: selected.id,
        service_name: selected.service_name,
        unit_price: Number(selected.unit_price || 0),
        unit: selected.unit || "",
        hsn_code: "",
      },
    ]);

    form.setFieldsValue({ service_id: null });
  };

  const getAllServicetype = async () => {
    try {
      const request = await ServicetypeService.getAllServicesType();
      setOptionServiceType(
        request.data.map((item) => ({
          value: item.id,
          label: item.type_name
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getAllStatus = async () => {
    try {
      const request = await ConfigurationService.getByType("enquiry_status");
      setOptionStatus(
        (request.data || []).map((item) => ({
          value: item.label,
          label: item.label,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getAllLeadSource = async () => {
    try {
      const request = await ConfigurationService.getByType("lead_source");
      setOptionLeadSource(
        (request.data || []).map((item) => ({
          value: item.label,
          label: item.label,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getAllIndustryType = async () => {
    try {
      const request = await ConfigurationService.getByType("industry_type");
      setOptionIndustry(
        (request.data || []).map((item) => ({ value: item.label, label: item.label }))
      );
    } catch (error) { console.error(error); }
  };

  const getAllDeploymentType = async () => {
    try {
      const request = await ConfigurationService.getByType("deployment_type");
      setOptionDeployment(
        (request.data || []).map((item) => ({ value: item.label, label: item.label }))
      );
    } catch (error) { console.error(error); }
  };

  const getAllFollowUpType = async () => {
    try {
      const request = await ConfigurationService.getByType("follow_up_type");
      setOptionFollowUpType(
        (request.data || []).map((item) => ({ value: item.label, label: item.label }))
      );
    } catch (error) { console.error(error); }
  };

  const getAllCountries = async () => {
    try {
      const res = await fetch("https://countriesnow.space/api/v0.1/countries/states");
      const json = await res.json();
      const list = (json.data || []).map((c) => ({
        value: c.name,
        label: c.name,
        states: (c.states || []).map((s) => ({ value: s.name, label: s.name })),
      }));
      setCountries(list);
    } catch (e) { console.error(e); }
  };

  const getCountryCurrencies = async () => {
    try {
      const res = await fetch("https://countriesnow.space/api/v0.1/countries/currency");
      const json = await res.json();
      const map = {};
      (json.data || []).forEach((c) => { map[c.name] = c.currency; });
      setCurrencyMap(map);
    } catch (e) { console.error(e); }
  };

  const handleCountryChange = (countryName) => {
    const c = countries.find((x) => x.value === countryName);
    setStateOptions(c ? c.states : []);
    form.setFieldsValue({
      state: null,
      currency: currencyMap[countryName] || null,   // auto-set currency
    });
  };

  const getAllCurrency = async () => {
    try {
      const request = await ServicetypeService.getAllCurrency();
      setCrncy(
        request.data.map((item) => ({
          value: item.code,
          label: `${item.code}- ${item.name}`
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getAllProducts = async () => {
    try {
      const request = await ServicetypeService.getAllProducts();

      const activeProducts = request.data.filter(
        item => item.status === "Active"
      );

      setAllProducts(activeProducts);

      setOptionProducts(
        activeProducts.map(item => ({
          value: item.id,
          label: item.name
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleProductChange = (productId) => {
    const selected = allProducts.find(
      (item) => Number(item.id) === Number(productId)
    );



    if (!selected) return;

    const alreadyAdded = selectedProducts.some(
      (item) => Number(item.product_id) === Number(selected.id)
    );

    if (alreadyAdded) return;

    setSelectedProducts([
      ...selectedProducts,
      {
        product_id: selected.id,
        product_name: selected.name,
        unit_price: Number(selected.unit_price || 0),
        unit: selected.unit || "",
        hsn_code: selected.hsn_code || selected.sku || selected.code_name || "",
      },
    ]);

    form.setFieldsValue({ product_id: null });
  };

  useEffect(() => {
    getAllServices();
    getAllServicetype();
    getAllStatus();
    getAllLeadSource();
    getAllIndustryType();
    getAllDeploymentType();
    getAllFollowUpType();
    getAllCountries();
    getCountryCurrencies();
    getAllUsers();
    getAllCurrency();
    getAllProducts();
  }, []);

  // REPLACE:
  useEffect(() => {
    if (initialValues?.eq_date) {
      form.setFieldsValue({ eq_date: dayjs(initialValues.eq_date) });
    }
    if (initialValues?.expected_go_live) {
      form.setFieldsValue({ expected_go_live: dayjs(initialValues.expected_go_live) });
    }
    if (initialValues?.assigned_to && typeof initialValues.assigned_to === 'string') {
      form.setFieldsValue({
        assigned_to: initialValues.assigned_to.split(',').map(s => s.trim()).filter(Boolean)
      });
    }
  }, [initialValues]);
  useEffect(() => {
    if (!initialValues?.eq_no) {
      generateEnquiryNo();
    } else {
      setEnquiryNo(initialValues.eq_no);
    }
  }, [initialValues]);

  useEffect(() => {
    if (initialValues?.follow_ups?.length) {
      setFollowUps(
        initialValues.follow_ups.map((item) => ({
          current_date: item.current_date
            ? dayjs(item.current_date).format("DD-MM-YYYY")
            : dayjs().format("DD-MM-YYYY"),
          date: item.follow_date ? dayjs(item.follow_date, "DD-MM-YYYY") : null,
          follow_up_type: item.follow_up_type || null,
          summary: item.summary || "",
          follow_up_by: item.follow_up_by || "",
        }))
      );
      return;
    }

    if (initialValues && (initialValues.n_follow_up || initialValues.summary || initialValues.notes)) {
      setFollowUps([
        {
          current_date: initialValues.followup_current_date
            ? dayjs(initialValues.followup_current_date).format("DD-MM-YYYY")
            : dayjs().format("DD-MM-YYYY"),
          date: initialValues.n_follow_up ? dayjs(initialValues.n_follow_up) : null,
          summary: initialValues.summary || initialValues.notes || "",
        },
      ]);
    }
  }, [initialValues]);

  useEffect(() => {
    if (!initialValues) {
      setSelectedServices([]);
      return;
    }

    let savedServices = [];

    if (Array.isArray(initialValues.service_items)) {
      savedServices = initialValues.service_items;
    } else if (typeof initialValues.service_items === "string") {
      try {
        savedServices = JSON.parse(initialValues.service_items || "[]");
      } catch {
        savedServices = [];
      }
    }

    setSelectedServices(savedServices);
  }, [initialValues]);

  useEffect(() => {
    if (!initialValues) {
      setSelectedProducts([]);
      return;
    }

    let savedProducts = [];

    if (Array.isArray(initialValues.product_items)) {
      savedProducts = initialValues.product_items;
    } else if (typeof initialValues.product_items === "string") {
      try {
        savedProducts = JSON.parse(initialValues.product_items || "[]");
      } catch {
        savedProducts = [];
      }
    }

    setSelectedProducts(savedProducts);
  }, [initialValues]);

  const generateEnquiryNo = async () => {
    const now = new Date();
    const day = now.getDate().toString().padStart(2, '0');
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const prefix = `${day}${month}`;

    let newSeq = '001';
    try {
      const request = await EnquiryService.getLastEnquiry();
      if (request?.status && request?.data?.eq_id) {
        const seqPart = request.data.eq_id.split('-').pop();
        const parsed = parseInt(seqPart, 10);
        if (!isNaN(parsed)) {
          newSeq = String(parsed + 1).padStart(3, '0');
        }
      }
    } catch (error) {
      console.error(error);
    }

    const newEnquiryNo = `${prefix}-${newSeq}`;
    setEnquiryNo(newEnquiryNo);
    handleEQNo(newEnquiryNo);
    form.setFieldsValue({ eq_no: newEnquiryNo });
    form.setFieldsValue({ eq_date: dayjs() });
  };

  const buildFinalData = (values, isDraft = false) => ({
    ...values,
    eq_no: enquiryNo,
    is_draft: isDraft,
    eq_date: values.eq_date ? dayjs(values.eq_date).format("YYYY-MM-DD") : null,
    reference_campaign: values.reference_campaign || null,
    company_name: values.company_name || null,
    industry_type: values.industry_type || null,
    website: values.website || null,
    company_size: values.company_size || null,
    number_of_employees: values.number_of_employees ?? null,
    annual_revenue: values.annual_revenue || null,
    location_city: values.location_city || null,
    state: values.state || null,
    country: values.country || null,
    address: values.address || null,
    gstin: values.gstin || null,
    contact_designation: values.contact_designation || null,
    contact_whatsapp: values.contact_whatsapp || null,
    contact_email: values.contact_email || null,
    contact_alt_email: values.contact_alt_email || null,
    current_software: values.current_software || null,
    current_process: values.current_process || null,
    existing_erp: values.existing_erp || null,
    pain_points: values.pain_points || null,
    requirement_priority: values.requirement_priority || null,
    expected_go_live: values.expected_go_live ? dayjs(values.expected_go_live).format("YYYY-MM-DD") : null,
    estimated_users: values.estimated_users ?? null,
    budget_range: values.budget_range || null,
    deployment_type: values.deployment_type || null,
    requirement_summary: values.requirement_summary || null,
    assigned_to: Array.isArray(values.assigned_to) ? values.assigned_to.join(', ') : values.assigned_to || null,
    total_amount: values.total_amount,
    service_total: serviceTotal,
    product_total: productTotal,
    service_items: selectedServices,
    product_items: selectedProducts,
    follow_ups: followUps.map((item) => ({
      current_date: item.current_date
        ? dayjs(item.current_date).format("DD-MM-YYYY")
        : dayjs().format("DD-MM-YYYY"),
      follow_date: item.date ? dayjs(item.date).format("DD-MM-YYYY") : null,
      follow_up_type: item.follow_up_type || null,
      summary: item.summary,
      follow_up_by: item.follow_up_by || null,
    })),
  });

  const handleFinish = async (values) => {
    try {
      onSubmit(buildFinalData(values, false));
    } catch (error) {
      console.error(error);
    }
  };

  const handleSaveDraft = () => {
    const values = form.getFieldsValue();
    onSubmit(buildFinalData(values, true));
  };

  useEffect(() => {
    if (initialValues?.country && countries.length) {
      const c = countries.find((x) => x.value === initialValues.country);
      setStateOptions(c ? c.states : []);
    }
  }, [initialValues, countries]);

  return (
    <>
      <style>{compactFormStyle}</style>
      <div style={{ marginTop: 8 }}>

        <Form form={form} layout="vertical" initialValues={initialValues || {}} onFinish={handleFinish} size="middle">
          <Form.Item name="currency" hidden><Input /></Form.Item>
          <Card title={<CardTitle icon={<FileTextOutlined />} no={1} text="Enquiry Information" />} style={{ marginBottom: 10 }}>

            <Row gutter={16}>
              <Col xs={24} sm={12} md={6}>
                <Form.Item name="eq_no" label="Enquiry No">
                  <Input size="large" readOnly />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item name="eq_date" label="Enquiry Date">
                  <DatePicker size="large" style={{ width: '100%' }} format="DD-MM-YYYY" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  name="eq_source"
                  label="Lead Source (Configuration)"

                >
                  <Select
                    options={optionLeadSource}
                    size="large"
                    showSearch
                    allowClear
                    placeholder="Select lead source"
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item name="reference_campaign" label="Reference / Campaign (Optional)">
                  <Input size="large" placeholder="Enter reference or campaign" />
                </Form.Item>
              </Col>
            </Row>

          </Card>

          <Card title={<CardTitle icon={<BankOutlined />} no={2} text="Company Information" />} style={{ marginBottom: 24 }}>

            <Row gutter={16}>
              <Col xs={24} sm={12} md={8}>
                <Form.Item name="company_name" label="Company Name"
                  rules={[{ required: true, message: 'Please enter company name' }]}>
                  <Input size="large" placeholder="Enter company name" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="industry_type" label="Industry Type (Configuration)"
                  rules={[{ required: true, message: 'Please select industry type' }]}>

                  <Select
                    options={optionIndustry}
                    size="large" showSearch allowClear
                    placeholder="Select industry"
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="website" label="Website">
                  <Input size="large" placeholder="Enter website" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="company_size" label="Company Size">
                  <Select options={companySizeOptions} size="large" allowClear
                    placeholder="Select company size" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="number_of_employees" label="Number of Employees">
                  <InputNumber size="large" min={0} style={{ width: '100%' }}
                    placeholder="Enter number of employees" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="annual_revenue" label="Annual Revenue (Optional)">
                  <Select options={annualRevenueOptions} size="large" allowClear
                    placeholder="Select annual revenue" />
                </Form.Item>
              </Col>



              <Col xs={24} sm={12} md={8}>
                <Form.Item name="country" label="Country">
                  <Select
                    options={countries}
                    size="large" showSearch allowClear
                    placeholder="Select country"
                    onChange={handleCountryChange}
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  />
                </Form.Item>
              </Col>



              <Col xs={24} sm={12} md={8}>
                <Form.Item name="state" label="State">
                  <Select
                    options={stateOptions}
                    size="large" showSearch allowClear
                    placeholder="Select state"
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  />
                </Form.Item>
              </Col>


              <Col xs={24} sm={12} md={8}>
                <Form.Item name="location_city" label="Location / City"
                  rules={[{ required: true, message: 'Please enter city / location' }]}>
                  <Input size="large" placeholder="Enter city / location" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={12}>
                <Form.Item name="address" label="Address">
                  <TextArea rows={1} size="large" style={{ minHeight: 40 }} placeholder="Enter full address" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={12}>
                <Form.Item name="gstin" label="GSTIN ">
                  <Input size="large" placeholder="Enter GSTIN" />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card title={<CardTitle icon={<UserOutlined />} no={3} text="Contact Person Details" />} style={{ marginBottom: 24 }}>

            <Row gutter={16}>
              <Col xs={24} sm={12} md={8}>
                <Form.Item name="name" label="Contact Person Name"
                  rules={[{ required: true, message: 'Please enter name' }]}>
                  <Input size="large" placeholder="Enter full name" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="contact_designation" label="Designation">
                  <Input size="large" placeholder="Enter designation" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="mobile_no" label="Mobile Number"
                  rules={[{ required: true, message: 'Please enter mobile number' }]}>
                  <Input size="large" placeholder="Enter mobile number" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="contact_whatsapp" label="WhatsApp Number">
                  <Input size="large" placeholder="Enter WhatsApp number" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="contact_email" label="Email Address"
                >
                  <Input size="large" placeholder="Enter email address" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="contact_alt_email" label="Alternate Email (Optional)"
                  rules={[{ type: 'email', message: 'Please enter a valid email' }]}>
                  <Input size="large" placeholder="Enter alternate email" />
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Card title={<CardTitle icon={<ShoppingOutlined />} no={4} text="Products / Services Requirements" />} style={{ marginBottom: 24 }}>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item label="Add Service">
                  <Select
                    mode="multiple"
                    options={optionService}
                    size="large" showSearch allowClear
                    placeholder="Select a service"
                    value={selectedServices.map((s) => s.service_id)}
                    tagRender={() => null}
                    maxTagCount={0}
                    onChange={(ids) => {
                      const next = ids.map((id) => {
                        const existing = selectedServices.find(
                          (s) => Number(s.service_id) === Number(id));
                        if (existing) return existing;
                        const svc = allServices.find((x) => Number(x.id) === Number(id));
                        return {
                          service_id: svc.id,
                          service_name: svc.service_name,
                          unit_price: Number(svc.unit_price || 0),
                          unit: svc.unit || "",
                          hsn_code: "",
                        };
                      });
                      setSelectedServices(next);
                    }}
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item label="Add Product">
                  <Select
                    mode="multiple"
                    options={optionProducts}
                    size="large" showSearch allowClear
                    placeholder="Select a product"
                    value={selectedProducts.map((p) => p.product_id)}
                    tagRender={() => null}
                    maxTagCount={0}
                    onChange={(ids) => {
                      const next = ids.map((id) => {
                        const existing = selectedProducts.find(
                          (p) => Number(p.product_id) === Number(id));
                        if (existing) return existing;
                        const prod = allProducts.find((x) => Number(x.id) === Number(id));
                        return {
                          product_id: prod.id,
                          product_name: prod.name,
                          unit_price: Number(prod.unit_price || 0),
                          unit: prod.unit || "",
                          hsn_code: prod.hsn_code || prod.sku || prod.code_name || "",
                        };
                      });
                      setSelectedProducts(next);
                    }}
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* Selected Services grid */}
            {selectedServices.length > 0 && (
              <>
                <Typography.Text strong>Selected Services</Typography.Text>
                <div style={{
                  display: "flex", flexWrap: "wrap", gap: 8,
                  marginTop: 8, marginBottom: 16,
                }}>
                  {selectedServices.map((item, index) => (
                    <div key={index} style={{
                      flex: "0 0 calc(20% - 7px)", maxWidth: "calc(20% - 7px)",
                      padding: "8px 10px", border: "1px solid #d9d9d9", borderRadius: 8,
                      background: "#f6ffed",
                    }}>
                      <Checkbox checked
                        onChange={() =>
                          setSelectedServices(selectedServices.filter((_, i) => i !== index))}>
                        {item.service_name}
                      </Checkbox>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* Selected Products grid */}
            {selectedProducts.length > 0 && (
              <>
                <Typography.Text strong>Selected Products</Typography.Text>
                <div style={{
                  display: "flex", flexWrap: "wrap", gap: 8,
                  marginTop: 8, marginBottom: 16,
                }}>
                  {selectedProducts.map((item, index) => (
                    <div key={index} style={{
                      flex: "0 0 calc(20% - 7px)", maxWidth: "calc(20% - 7px)",
                      padding: "8px 10px", border: "1px solid #d9d9d9", borderRadius: 8,
                      background: "#e6f4ff",
                    }}>
                      <Checkbox checked
                        onChange={() =>
                          setSelectedProducts(selectedProducts.filter((_, i) => i !== index))}>
                        {item.product_name}
                      </Checkbox>
                    </div>
                  ))}
                </div>
              </>
            )}

            <Divider style={{ margin: "16px 0" }} />

            {/* <Row gutter={16} align="middle" justify="end">
          <Col xs={24} sm={8} md={6}>
            <Form.Item name="currency" label="Currency" style={{ marginBottom: 0 }}>
              <Select
                size="large"
                placeholder="Select currency"
                allowClear
                options={optionCrncy}
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
              />
            </Form.Item>
          </Col>
          <Col>
            <Typography.Text strong style={{ fontSize: 16 }}>
              Estimated Price: {selectedCurrency || ""} {serviceTotal + productTotal}
            </Typography.Text>
          </Col>
        </Row> */}

            <Row justify="end">
              <Col>
                <Typography.Text strong style={{ fontSize: 16 }}>
                  Estimated Price: {selectedCurrency || ""} {serviceTotal + productTotal}
                </Typography.Text>
              </Col>
            </Row>
          </Card>

          {/* 
      <Card title="Product Details" style={{ marginBottom: 24 }}>
        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item name="product_id" label="Product">
              <Select
                options={optionProducts}
                size="large"
                showSearch
                allowClear
                placeholder="Select product"
                onChange={handleProductChange}
                filterOption={(input, option) =>
                  (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>
        </Row>

        {selectedProducts.length > 0 && (
          <div style={{ marginTop: 12 }}>
            <Row gutter={16} style={{ marginBottom: 6 }}>
              <Col span={10}><b>Product Name</b></Col>
              <Col span={6}><b>Unit Price</b></Col>
              <Col span={4}></Col>
            </Row>

            {selectedProducts.map((item, index) => (
              <Row key={index} gutter={16} style={{ marginBottom: 8 }}>
                <Col span={10}>
                  <Input value={item.product_name} readOnly />
                </Col>

                <Col span={6}>
                  <InputNumber
                    value={Number(item.unit_price || 0)}
                    readOnly
                    style={{ width: "100%" }}
                  />
                </Col>

                <Col span={4}>
                  <Button
                    danger
                    onClick={() =>
                      setSelectedProducts(
                        selectedProducts.filter((_, i) => i !== index)
                      )
                    }
                  >
                    Remove
                  </Button>
                </Col>
              </Row>
            ))}

            <Row justify="end" style={{ marginTop: 10 }}>
              <Col>
                <b>Product Total: {productTotal}</b>
              </Col>
            </Row>
          </div>
        )}
      </Card> */}

          {/* <Card title="Service & Financial Details" style={{ marginBottom: 24 }}>
        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item name="service_type_id" label="Service Type">
              <Select
                options={optionServiceType}
                size="large"
                showSearch
                allowClear
                placeholder="Select a service Type"
                filterOption={(input, option) =>
                  (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item name="total_amount" label="Total Amount">
              <InputNumber
              allowClear
              size="large"
              style={{ width: '100%' }}
            />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item name="currency" label="Currency">
              <Select
                size="large"
                placeholder="Select currency"
                allowClear
                options={optionCrncy}
                showSearch
                filterOption={(input, option) =>
                  (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>
        </Row>
      </Card> */}

          <Row gutter={16} style={{ marginBottom: 10 }}>
            {/* Left: Current System Details */}
            <Col xs={24} lg={12}>
              <Card title={<CardTitle icon={<DesktopOutlined />} no={5} text="Current System Details" />} style={{ height: '100%' }}>

                <Row gutter={16}>
                  <Col xs={24} sm={12}>
                    <Form.Item name="current_software" label="Current Software Used">
                      <Input size="large" placeholder="Enter current software" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item name="current_process" label="Current Process"
                    >
                      <Select options={currentProcessOptions} size="large" allowClear
                        placeholder="Select current process" />
                    </Form.Item>
                  </Col>
                  <Col xs={24}>
                    <Form.Item
                      name="existing_erp"
                      label="Existing ERP / Website / App / Other (If Any)"
                    >
                      <Input
                        size="large"
                        placeholder="Enter ERP, website, app, or other system details"
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24}>
                    <Form.Item name="pain_points" label="Pain Points / Challenges"
                    >
                      <TextArea rows={3} size="large"
                        placeholder="Describe your current challenges and pain points" />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>

            {/* Right: Project Requirement */}
            <Col xs={24} lg={12}>
              <Card title={<CardTitle icon={<ProjectOutlined />} no={6} text="Project Requirement" />} style={{ height: '100%' }}>

                <Row gutter={16}>
                  <Col xs={24} sm={12}>
                    <Form.Item name="requirement_priority" label="Requirement Priority"
                      rules={[{ required: true, message: 'Please select priority' }]}>
                      <Select options={priorityOptions} size="large" allowClear
                        placeholder="Select priority" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item name="expected_go_live" label="Expected Go-Live Date">
                      <DatePicker size="large" style={{ width: '100%' }} format="DD-MM-YYYY"
                        placeholder="Select date" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item name="estimated_users" label="Estimated Users">
                      <InputNumber size="large" min={0} style={{ width: '100%' }}
                        placeholder="Enter estimated users" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item name="budget_range" label="Budget Range"
                    >
                      <Select options={budgetRangeOptions} size="large" allowClear
                        placeholder="Select budget range" />
                    </Form.Item>
                  </Col>
                  <Col xs={24}>
                    <Form.Item name="deployment_type" label="Deployment Type (Configuration)"
                    >
                      <Select options={optionDeployment} size="large" showSearch allowClear
                        placeholder="Select deployment type"
                        filterOption={(input, option) =>
                          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())} />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          <Card title={<CardTitle icon={<FileSearchOutlined />} no={7} text="Requirement Summary" />} style={{ marginBottom: 24 }}>

            <Form.Item name="requirement_summary"
              label="Explain Your Business Process, Requirements & Expected Features"
            >
              <TextArea rows={4} size="large"
                placeholder="Please describe your business process, current workflow, key challenges, and your expected features." />
            </Form.Item>
          </Card>
          <Card title={<CardTitle icon={<PhoneOutlined />} no={8} text="Sales Follow-up Information" />} style={{ marginBottom: 24 }}>

            <Row gutter={16}>
              <Col xs={24} sm={12} md={8}>
                <Form.Item name="eq_status" label="Enquiry Status (Configuration)"
                  rules={[{ required: true, message: 'Please select status' }]}>
                  <Select options={optionStatus} size="large" showSearch allowClear
                    placeholder="Select a status"
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8}>
                <Form.Item name="assigned_to" label="Assigned To"
                  rules={canViewAll ? [{ required: false, message: '' }] : []}>
                  <Select
                    mode="multiple"
                    options={canViewAll ? optionUsers : []}
                    disabled={!canViewAll}
                    open={canViewAll ? undefined : false}
                    size="large"
                    showSearch
                    allowClear={canViewAll}
                    placeholder="Select assigned user(s)"
                    maxTagCount="responsive"
                    maxTagPlaceholder={(omitted) => {
                      const val = form.getFieldValue('assigned_to');
                      const title = Array.isArray(val) ? val.join(', ') : val || '';
                      return (
                        <Tooltip title={title}>
                          <span>+{omitted.length} more</span>
                        </Tooltip>
                      );
                    }}
                    menuItemSelectedIcon={<span style={{ color: 'rgba(11, 93, 148, 0.95)', fontWeight: 700 }}>✓</span>}
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  />
                </Form.Item>
              </Col>
            </Row>


            <Row gutter={16}>
              <Col xs={24} md={6}>
                <Form.Item label="Follow-up Date">
                  <DatePicker size="large" style={{ width: "100%" }} format="DD-MM-YYYY"
                    value={followUpInput.date}
                    onChange={(value) => setFollowUpInput({ ...followUpInput, date: value })} />
                </Form.Item>
              </Col>

              <Col xs={24} md={6}>
                <Form.Item label="Follow-up Type (Configuration)">
                  <Select options={optionFollowUpType} size="large" showSearch allowClear
                    placeholder="Select type"
                    value={followUpInput.follow_up_type}
                    onChange={(value) => setFollowUpInput({ ...followUpInput, follow_up_type: value })}
                    filterOption={(input, option) =>
                      (option?.label ?? "").toLowerCase().includes(input.toLowerCase())} />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item label="Next Action / Remarks">
                  <Input.TextArea size="large" value={followUpInput.summary}
                    rows={1}
                    style={{ minHeight: 40 }}
                    placeholder="Enter next action or remarks"
                    onChange={(e) => setFollowUpInput({ ...followUpInput, summary: e.target.value })} />
                </Form.Item>
              </Col>
            </Row>

            <Button
              type="primary"
              onClick={handleAddFollowUp}
              style={{
                backgroundColor: "rgba(14, 93, 146, 0.95)",
                borderColor: "rgba(14, 93, 146, 0.95)"
              }}
            >
              + Add Follow-up
            </Button>

            {followUps.length > 0 && (
              <>
                <Typography.Text strong style={{ fontSize: 15, display: "block", marginTop: 20 }}>
                  Follow-up Details
                </Typography.Text>
                <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 10 }}>
                  <thead>
                    <tr style={{ background: "#fafafa" }}>
                      <th style={{ textAlign: "left", padding: "10px 12px", border: "1px solid #f0f0f0", width: "20%" }}>Follow-up Date</th>
                      <th style={{ textAlign: "left", padding: "10px 12px", border: "1px solid #f0f0f0", width: "20%" }}>Follow-up Type</th>
                      <th style={{ textAlign: "left", padding: "10px 12px", border: "1px solid #f0f0f0" }}>Next Action / Remarks</th>
                      <th style={{ textAlign: "left", padding: "10px 12px", border: "1px solid #f0f0f0", width: "18%" }}>Follow-up By</th>

                    </tr>
                  </thead>
                  <tbody>
                    {followUps.map((item, index) => (
                      <tr key={index}>
                        <td style={{ padding: "10px 12px", border: "1px solid #f0f0f0" }}>
                          {item.date ? dayjs(item.date).format("DD-MM-YYYY") : "-"}
                        </td>
                        <td style={{ padding: "10px 12px", border: "1px solid #f0f0f0" }}>
                          {item.follow_up_type || "-"}
                        </td>
                        <td style={{ padding: "10px 12px", border: "1px solid #f0f0f0" }}>
                          {item.summary || "-"}
                        </td>
                        <td style={{ padding: "10px 12px", border: "1px solid #f0f0f0" }}>
                          {item.follow_up_by || "-"}
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </Card>

          <div style={{ textAlign: 'right', marginTop: 24 }}>
            <Button
              onClick={onCancel}
              style={{
                marginRight: 8,
                color: "rgba(14, 93, 146, 0.95)",
                borderColor: "rgba(14, 93, 146, 0.95)"
              }}
              size="large"
            >
              Cancel
            </Button>

            <Button
              onClick={handleSaveDraft}
              style={{
                marginRight: 8,
                color: "rgba(14, 93, 146, 0.95)",
                borderColor: "rgba(14, 93, 146, 0.95)"
              }}
              size="large"
            >
              {initialValues?.eq_no ? "Update Draft" : "Save Draft"}
            </Button>

            <Button
              type="primary"
              htmlType="submit"
              size="large"
              style={{
                backgroundColor: "rgba(14, 93, 146, 0.95)",
                borderColor: "rgba(14, 93, 146, 0.95)"
              }}
            >
              {initialValues?.eq_no ? "Update Enquiry" : "Create Enquiry"}
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
};

export default CreateEnquiry;